var render = function render(){var _vm=this,_c=_vm._self._c;return (this.data.values)?_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"area","height":"300","width":"100%","options":_vm.chartOptions,"series":_vm.series}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }